import { createSlice } from '@reduxjs/toolkit';

const deleteMultipleScansModalState = {
  modalState: false,
  singleSiteData: {
    url: ''
  },
  isMultipleDelete: false,
  siteData: [],
  prevoiusScanData: []
};

// Redux states initialization
const initialState = {
  isLoadingUserDetails: true,
  sitesDetails: {}, // Details of all sites
  userEmail: '', // Details of User Email
  userDetails: {
    _id: '',
    created_at: '',
    date_format: ''
  }, // Details of User Details
  modalclose: false, // Common modal close trigger
  subscriptionEdited: false, // Subscription change trigger
  planChanged: false, // Plan change trigger
  affiliateUrl: '', //affiliate Url
  addonDetails: [], // user addon details
  scanDetails: {},
  hostName: '', // Runscan host name for loading real time
  deleteMainSite: false,
  isCallLoginScan: false,
  deleteMultipleScansModalState: {
    ...deleteMultipleScansModalState
  },
  isLocalSEOAddonBuy: false,
  isCancelSiteTransferModalOpen: false
};

/**
 * Redux slice for managing counter-related state.
 *
 * @name counterSlice
 * @type {Slice}
 */
// Action functions declaration
export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    /**
     * Set the details of all sites.
     *
     * @function
     * @name statSitesDetails
     * @param {Object} state - The current state.
     * @param {Object} actions - The action with payload.
     */
    statSitesDetails: (state, actions) => {
      state.sitesDetails = actions.payload;
    },
    stateUserDetails: (state, actions) => {
      state.userDetails = actions.payload;
    },
    setUserEmail: (state, actions) => {
      state.userEmail = actions.payload;
    },
    setModalClose: (state, actions) => {
      state.modalclose = actions.payload;
    },
    setSubscriptionEdited: (state, actions) => {
      state.subscriptionEdited = actions.payload;
    },
    setPlanChanged: (state, actions) => {
      state.planChanged = actions.payload;
    },
    setAffiliateUrl: (state, actions) => {
      state.affiliateUrl = actions.payload;
    },
    setAddonDetails: (state, actions) => {
      state.addonDetails = actions.payload;
    },
    setScanDetails: (state, actions) => {
      state.scanDetails = actions.payload;
    },
    setHostName: (state, actions) => {
      state.hostName = actions.payload;
    },
    setIsLoginScan: (state, actions) => {
      state.isCallLoginScan = actions.payload;
    },
    setIsLocalSEOAddonBuy: (state, actions) => {
      state.isLocalSEOAddonBuy = actions.payload;
    },
    setIsLoadingUserDetails: (state, actions) => {
      state.isLoadingUserDetails = actions.payload;
    },
    handleDeleteMultipleScanModal: (state, actions) => {
      if (actions.payload.reset) {
        state.deleteMultipleScansModalState = {
          ...deleteMultipleScansModalState
        };
        return;
      }
      state.deleteMultipleScansModalState = {
        ...state.deleteMultipleScansModalState,
        ...actions.payload
      };
    },
    setIsCancelSiteTransferModalOpen: (state, actions) => {
      state.isCancelSiteTransferModalOpen = actions.payload;
    },
    /**
     * Clean up and reset the state to its initial values.
     *
     * @function
     * @name cleanupInitialState
     */
    cleanupInitialState: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  statSitesDetails,
  stateUserDetails,
  setUserEmail,
  cleanupInitialState,
  setModalClose,
  setSubscriptionEdited,
  setPlanChanged,
  setAffiliateUrl,
  setAddonDetails,
  setScanDetails,
  setHostName,
  setIsLoginScan,
  setIsLocalSEOAddonBuy,
  handleDeleteMultipleScanModal,
  setIsLoadingUserDetails,
  setIsCancelSiteTransferModalOpen
} = counterSlice.actions;

export default counterSlice.reducer;
